import type { ProfileManifest, ThemeRegistryEntry } from "../contracts";

export const PROFILE_TOKEN_TO_CSS_VARIABLE = {
    "content.maxWidth": "--content-max-width",
    "content.fontSize": "--content-font-size",
    "content.lineHeight": "--content-line-height",
    "content.paragraphSpacing": "--content-paragraph-spacing",
    "content.headingSpacing": "--content-heading-spacing",
    "content.blockSpacing": "--content-block-spacing",
    "content.inlineCodeFontSize": "--content-inline-code-font-size",
    "content.codeBlockFontSize": "--content-code-block-font-size",
    "content.listIndent": "--content-list-indent",
    "content.surfacePadding": "--content-surface-padding",
    "presentation.maxWidth": "--presentation-max-width",
    "presentation.fontSize": "--presentation-font-size",
    "presentation.lineHeight": "--presentation-line-height",
    "presentation.paragraphSpacing": "--presentation-paragraph-spacing",
    "presentation.headingSpacing": "--presentation-heading-spacing",
    "presentation.blockSpacing": "--presentation-block-spacing",
    "presentation.surfacePadding": "--presentation-surface-padding",
} as const;

export type ProfileTokenId = keyof typeof PROFILE_TOKEN_TO_CSS_VARIABLE;

const PROFILE_TOKEN_METADATA = {
    "content.maxWidth": "Rendered content maximum width.",
    "content.fontSize": "Rendered content font size.",
    "content.lineHeight": "Rendered content line height.",
    "content.paragraphSpacing": "Rendered content paragraph spacing.",
    "content.headingSpacing": "Rendered content heading spacing.",
    "content.blockSpacing": "Rendered content block spacing.",
    "content.inlineCodeFontSize": "Rendered content inline code font size.",
    "content.codeBlockFontSize": "Rendered content code block font size.",
    "content.listIndent": "Rendered content list indent.",
    "content.surfacePadding": "Rendered content surface padding.",
    "presentation.maxWidth": "Published presentation maximum width.",
    "presentation.fontSize": "Published presentation font size.",
    "presentation.lineHeight": "Published presentation line height.",
    "presentation.paragraphSpacing": "Published presentation paragraph spacing.",
    "presentation.headingSpacing": "Published presentation heading spacing.",
    "presentation.blockSpacing": "Published presentation block spacing.",
    "presentation.surfacePadding": "Published presentation surface padding.",
} as const satisfies Record<ProfileTokenId, string>;

export const PROFILE_TOKEN_REGISTRY: ThemeRegistryEntry<ProfileTokenId>[] = (
    Object.keys(PROFILE_TOKEN_TO_CSS_VARIABLE) as ProfileTokenId[]
).map((id) => ({
    id,
    cssVariable: PROFILE_TOKEN_TO_CSS_VARIABLE[id],
    description: PROFILE_TOKEN_METADATA[id],
    domain: id.startsWith("presentation.") ? "content" : "content",
    public: true,
}));

export const KNOWN_PROFILE_VARIABLES = Object.values(
    PROFILE_TOKEN_TO_CSS_VARIABLE,
);

export function createProfileRegistry(
    manifests: ProfileManifest<ProfileTokenId>[],
): Map<string, ProfileManifest<ProfileTokenId>> {
    return new Map(manifests.map((manifest) => [manifest.id, manifest]));
}
